import FacebookLogo from "../../Images/facebookLogo.svg";
import "./style.scss";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="Footer">
      <div className="footerContainer">
        <div className="footerSection">
          <p className="companyTitle">
            &copy; {currentYear} Farnham and District Window Cleaning
          </p>
        </div>

        <div className="footerSection contactInfo">
          <span>01252726833</span>
          <span className="dot">&bull;</span>
          <span>w.stewart76@btinternet.com</span>
        </div>

        <div className="footerSection socialLinks">
          <img
            className="footerImg"
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=100054523986920",
              )
            }
            src={FacebookLogo}
            alt="Facebook"
          />
          <p className="builtBy">
            Built by{" "}
            <a
              href="https://danielfstewart.com/"
              target="_blank"
              rel="noreferrer"
            >
              Daniel Stewart
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
